import React from 'react'
import { PostForm } from './PostForm'
import { RecruiterNavbar } from '../RecruiterNavbar/RecruiterNavbar'

export const Show = () => {
    return (
        <div>
            <RecruiterNavbar />
            <PostForm />
        </div>
    )
}
